import EncryptRsa from 'encrypt-rsa';

const encryptRsa = new EncryptRsa();

export default function encryptData(data: string): string {
    try {
        if (!data || typeof data !== 'string') {
            throw new Error('Invalid data format');
        }

        const publicKey = `-----BEGIN PUBLIC KEY-----
        ${process.env["NEXT_PUBLIC_RSA_PUBLIC_KEY"]}
        -----END PUBLIC KEY-----`.trim();

        if (!publicKey.includes('BEGIN PUBLIC KEY')) {
            throw new Error('Invalid public key format');
        }

        const result = encryptRsa.encryptStringWithRsaPublicKey({
            text: data,
            publicKey
        });

        if (!result) {
            throw new Error('Empty encryption result');
        }

        return result;
    } catch (error) {
        console.error('Encryption error:', error);
        throw new Error('Failed to encrypt: ' + (error as Error).message);
    }
}
